var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireWhite = function SvgFireWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.963 18.93c0 1.968-1.772 3.56-3.963 3.56s-3.963-1.592-3.963-3.56c0-2.877 3.963-6.457 3.963-6.457s3.963 3.407 3.963 6.456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 1.5 8.778 7.734 6.351 6.528C4.547 8.69 3 11.411 3 14.413 3 18.88 7.027 22.5 12 22.5s9-3.619 9-8.087C20.99 7.513 12 1.5 12 1.5"
  })));
};
export default SvgFireWhite;